export const albumKeys = {
  detail: (id: number | string) => ["albums", "detail", id] as const,
  songs: (id: number | string) => ["albums", "songs", id] as const,
};
